module.exports = __webpack_public_path__ + "static/media/Theatre Seat Naming Project.9cb424ed.png";